export default "__VITE_ASSET__CSIAZ$9p__"